export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const FILTER_PRODUCTS_BY_SIZE = "FILTER_PRODUCTS_BY_SIZE";
export const ORDER_PRODUCTS_BY_PRICE = "ORDER_PRODUCTS_BY_PRICE";
export const LOAD_SETTING = "LOAD_SETTING";
export const [REGISTER_PROJECT,REGISTER_TABLE] = ["REGISTER_PROJECT","REGISTER_TABLE"];
export const CHANGE_LANG = "CHANGE_LANG";
export const [ADD_CART, MINUS_CART,CLONE_CART,CLEAR_CART] = ["ADD_CART","MINUS_CART","CLONE_CART","CLEAR_CART"];
export const [POST_INVOICE,LOAD_INVOICES] = ['POST_INVOICE','LOAD_INVOICES'];